import './ModalContent.65071f06a67f91f97d7a1850af66f719.css';
export default {"content":"_content_1odjl_1"};